import axios from "./axios-handler.service";
const BASE_URL = "/api/Atendimento";

export interface FormAtendimentoEnvio {
  numero: string | null;
  periodo: string;
  tipo: string | null;
  motivoFechamento: string | null;
  emailCliente: string;
  aberto: string | null;
  possuiDataAtendimento: string | null;
  nomeCliente: string;
  telefoneCliente: string;
  idUsuario: string | null;
  offset: string | null;
  limit: string | null;
  order: string;
}

export interface Consultor {
  idConsultor: number;
  nome: string;
  cpf: number;
  email: string;
  telefone: number;
  celular: number;
  versao: number;
  dataCadastro: string;
  dataUltimoLogin: string;
  statusCadastro: string;
  dataMigracao: string;
  statusAssinatura: boolean;
  listaCatalogos: Catalogo[];
  observacao: string;
}

export interface Catalogo {
  idCatalogo: string;
  idFornecedor: string;
  nome: string;
  descricao: string;
  tipo: string;
  ativo: boolean;
  dataCriacao: string;
}

export interface Assinatura {
  idAssinatura: number;
  ativo: boolean;
  meioPagamento: string;
  dataCadastro: string;
  dataCancelamento: string;
  motivoCancelamento: string;
  tipoPlano: Plano;
}

export interface Plano {
  idTipoPlano: string;
  ativo: string;
  nome: string;
}

export interface Atendimento {
  lista: any[];
  paginaAtual: number;
  registroAtual: number;
  tamanhoPagina: number;
  totalRegistros: number;
}

export interface RegistrarAtendimento {
  idAtendimento: number;
  status: StatusChamada;
  idMotivoFechamentoAtendimento: number | null;
  data: string;
  hora: string;
  observacao: string;
}

export enum StatusChamada {
  Reagendar = 1,
  SemContato = 2,
  FecharAtendimento = 9,
}
export interface DadoAtendimento {
  tipo: string;
  descricao: string;
  dataCriacao: string;
  status: boolean;
  responsavel: string;
  aberto: boolean;
}

export enum TipoAtendimento {
  SuporteSistema = 1,
  Treinamento = 2,
  PossivelCliente = 3,
  PlanoExpirado = 4,
  PlanoGratis10Dias = 5,
  FidelizarCliente = 6,
  Outros = 99,
}

export class AtendimentoService {
  static async ObterTipoAtendimento(): Promise<any[]> {
    const response = await axios.get<any[]>(`${BASE_URL}/ObterTipoAtendimento`);
    return response.data;
  }

  static async ObterMotivoFechamento(): Promise<any[]> {
    const response = await axios.get<any[]>(
      `${BASE_URL}/ObterMotivoFechamento`
    );
    return response.data;
  }

  static async ObterUsuarios(): Promise<any[]> {
    const response = await axios.get<any[]>(`${BASE_URL}/ObterUsuarios`);
    return response.data;
  }

  static async Lista(atendimento: FormAtendimentoEnvio): Promise<any> {
    const {
      numero,
      periodo,
      tipo,
      motivoFechamento,
      emailCliente,
      aberto,
      possuiDataAtendimento,
      nomeCliente,
      telefoneCliente,
      idUsuario,
      offset,
      limit,
      order,
    } = atendimento;
    const response = await axios.post<any>(`${BASE_URL}/Lista`, {
      numero,
      periodo,
      tipo,
      motivoFechamento,
      emailCliente,
      aberto,
      possuiDataAtendimento,
      nomeCliente,
      telefoneCliente,
      idUsuario,
      offset,
      limit,
      order,
    });
    return response.data;
  }

  static async ObterDadosConsultor(idConsultor: number): Promise<Consultor> {
    const response = await axios.get<Consultor>(
      `${BASE_URL}/ObterDadosConsultor`,
      {
        params: { idConsultor },
      }
    );
    return response.data;
  }

  static async ListarDadosAssinatura(
    idConsultor: number | null
  ): Promise<Assinatura> {
    const response = await axios.get<Assinatura>(
      `${BASE_URL}/ListarDadosAssinatura`,
      {
        params: { idConsultor },
      }
    );
    return response.data;
  }

  static async AtualizaAtendimento(
    idAtendimento: number
  ): Promise<DadoAtendimento> {
    const response = await axios.get<DadoAtendimento>(
      `${BASE_URL}/AtualizaAtendimento`,
      {
        params: { idAtendimento },
      }
    );
    return response.data;
  }

  static async PopAtendimento(idAtendimento: number): Promise<DadoAtendimento> {
    const response = await axios.get<DadoAtendimento>(
      `${BASE_URL}/PopAtendimento`,
      {
        params: { idAtendimento },
      }
    );
    return response.data;
  }

  static async RegistrarChamada(
    atendimento: RegistrarAtendimento
  ): Promise<any> {
    const {
      idAtendimento,
      status,
      idMotivoFechamentoAtendimento,
      data,
      hora,
      observacao,
    } = atendimento;
    const response = await axios.post<any>(`${BASE_URL}/RegistrarChamada`, {
      idAtendimento,
      status,
      idMotivoFechamentoAtendimento,
      data,
      hora,
      observacao,
    });
    return response.data;
  }

  static async AlterarResponsavel(
    idAtendimento: number,
    idResponsavel: number | null
  ): Promise<any> {
    const response = await axios.post<any>(`${BASE_URL}/AlterarResponsavel`, {
      idAtendimento,
      idResponsavel,
    });
    return response.data;
  }

  static async ObterUsuarioLogado(): Promise<number> {
    const response = await axios.get<number>(`${BASE_URL}/ObterUsuarioLogado`);
    return response.data;
  }
}
